module.exports = __webpack_public_path__ + "img/trophy.51f38971.svg";